export default {"src":"/_next/static/image/public/images/ic_checkbox_checked.f84ed619fb319740fda800db9406298c.svg","height":20,"width":20};